import {showNotification} from 'platform/components';

import {useSourcingGetPriceReportMutation} from '@dms/api/core';
import {i18n} from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {pushGtmEvent} from 'shared/web';

import {DEFAULT_SOURCING_TARGET_COUNTRY} from '../constants/DEFAULT_SOURCING_TARGET_COUNTRY';
import {useSourcingTargetCountry} from './useSourcingTargetCountry';
import {useSourcingType} from './useSourcingType';

const openInNewWindow = (url: string) => {
  const win = window.open(url, '_blank');
  win?.focus();
};

export function useCreatePriceReport(externalId: string) {
  const [getPriceReport, {isLoading: isPriceReportCreating}] = useSourcingGetPriceReportMutation();
  const targetCountry = useSourcingTargetCountry();
  const sourcingType = useSourcingType();

  const createPriceReport = () => {
    showNotification.info(i18n.t('general.notifications.creatingPriceReport'));
    getPriceReport({externalId, country: targetCountry?.code ?? DEFAULT_SOURCING_TARGET_COUNTRY})
      .unwrap()
      .then((data) => {
        pushGtmEvent({
          event: `sourcing_${sourcingType}_report_opened`,
          event_id: `sourcing_${sourcingType}_report_opened`,
          params: {target_country: targetCountry?.code ?? DEFAULT_SOURCING_TARGET_COUNTRY},
        });
        openInNewWindow(data.url);
      })
      .catch(handleApiError);
  };

  return {createPriceReport, isPriceReportCreating};
}
